module.exports = __webpack_public_path__ + "static/media/icono-personal.6c7f3f21.svg";